var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2871 24.7205V19.2802L19.2209 26.4355V17.3683M23.9227 16.7845L21.7819 15.6533V22.0003M21.7819 28.3473V22.0003M21.7819 22.0003H23.9227M25.6787 17.6568L26.9718 18.3689M26.9718 18.3689L28.6213 19.2802M26.9718 18.3689V26.1864M21.2294 12.5593L14.3412 16.4949C13.7179 16.8509 13.3333 17.5136 13.3333 18.2314V25.7585C13.3333 26.482 13.724 27.149 14.3551 27.5029L21.4061 31.4569C22.0087 31.7948 22.7432 31.7978 23.3485 31.4647L30.2975 27.6407C30.9364 27.2891 31.3333 26.6177 31.3333 25.8884V18.2474C31.3333 17.5211 30.9396 16.8519 30.3047 16.4991L23.1929 12.5476C22.5814 12.2079 21.8368 12.2123 21.2294 12.5593Z",
    stroke: "#1B202C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0.333313,
    y1: 0,
    x2: 44.3333,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftSquare);
export default __webpack_public_path__ + "static/media/nft-square.bc218d3b361efd810c54b02b1b3d2892.svg";
export { ForwardRef as ReactComponent };